import { getPendingChangesAuthorLabel } from 'utils/pendingChangesAuthors';

const joinNames = names => {
  if (names.length <= 1) {
    return names.join('');
  }

  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
};

const toPossessive = name => `${name}'s`;

/**
 * One-line description of whose pending changes the loan currently includes, or null when the loan
 * shows only the current user's own changes (today's default view).
 */
export const getPendingChangesAuthorsNotice = ({ selectedOtherAuthors, isCurrentUserSelected }) => {
  const names = joinNames(selectedOtherAuthors.map(getPendingChangesAuthorLabel));

  if (!selectedOtherAuthors.length) {
    return isCurrentUserSelected
      ? null
      : 'Showing the saved loan only. Your own changes are hidden; editing a field shows them again.';
  }

  if (!isCurrentUserSelected) {
    return `Showing only ${toPossessive(names)} changes. Your own changes are hidden; editing a field shows them again.`;
  }

  return `Also showing ${toPossessive(names)} changes. Values include them. Only your own changes are saved.`;
};
